'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import * as React from 'react'

// walrus
import { ENV } from '@lib/env'

// lib
import { validateTime, validateTimeErrorMessage } from '../validators'
import MaskedField, { MaskedFieldProps } from './masked-field'

/* -----------------------------------------------------------------------------
 * TimeField
 * -------------------------------------------------------------------------- */

export type TimeFieldProps = Omit<
  MaskedFieldProps,
  'label' | 'nativeMask' | 'webMask'
> & {
  label?: MaskedFieldProps['label']
}

const TimeField = ({ required, ...props }: TimeFieldProps) => {
  const requiredVal =
    required && typeof required === 'boolean'
      ? validateTimeErrorMessage
      : required

  return (
    <MaskedField
      label='Time'
      placeholder='HH:MM'
      nativeMask='[00]:[00]'
      webMask={[/\d/, /\d/, ':', /\d/, /\d/]}
      validate={validateTime()}
      required={requiredVal}
      {...(ENV['client_type'] === 'web' ? {} : { keyboardType: 'number-pad' })}
      {...props}
    />
  )
}

export default TimeField
